import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import { AvatarTypes } from '@mode/shared/contract-common';

@Component({
  selector: 'mode-user-access-avatar',
  templateUrl: './user-access-avatar.component.html',
  styleUrls: ['./user-access-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserAccessAvatarComponent implements OnChanges {
  @Input() avatar: AvatarTypes.Avatar | undefined;
  @Input() editAccess = false;
  public tooltipContent = '';
  public icon = 'icon-pencil';

  public ngOnChanges(): void {
    this.tooltipContent = `<div class="no-break">
      You are ${this.editAccess ? 'an <strong>Editor</strong>' : 'a <strong>Viewer</strong>'} for this Report
    </div>`;
    this.icon = this.editAccess ? 'icon-pencil' : 'icon-eye';
  }
}
